<script setup lang="ts">
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import type { Swiper as SwiperType } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export type OfferSliderProps = {
  offers: {
    name: string
    slug: string
    thumbnail: {
      src: string
      alt: string
    }
  }[]
}

defineProps<OfferSliderProps>()

const swiper = shallowRef<SwiperType>()
</script>

<template>
  <AlPadding side="none">
    <Swiper
      :modules="[Navigation, Pagination, A11y]"
      slides-per-view="auto"
      :space-between="20"
      :allow-touch-move="true"
      :pagination="{ clickable: true }"
      :center-insufficient-slides="true"
      class="relative !pb-8"
      @swiper="(_swiper) => (swiper = _swiper)"
    >
      <SwiperSlide v-for="offer in offers" :key="offer.slug" class="max-w-96">
        <AlOfferCard v-bind="offer" />
      </SwiperSlide>
    </Swiper>
  </AlPadding>
</template>
